import { defineComponent, onMounted, ref } from 'vue';
import { gsap } from 'gsap';
export default defineComponent({
    name: 'MainTitle',
    props: {
        title: {
            type: String,
            required: true,
        },
        subTitle: {
            type: String,
            required: false,
            default: 'common.hems',
        },
    },
    setup() {
        const titleWrap = ref();
        onMounted(() => {
            gsap.to([titleWrap.value], {
                rotateX: 0,
                duration: 0.4,
            });
        });
        return {
            titleWrap,
        };
    },
});
